import loadMenuSaga from './loadMenuDataSaga'
import { all, fork } from 'redux-saga/effects'

export default function* rootSaga() {
  yield all([
    fork(loadMenuSaga),
  ])
}
